import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { ChartModule } from '@progress/kendo-angular-charts';
import { GeographicThreatsResponse } from 'src/app/core/models/analytics/es-models';

@Component({
  selector: 'app-es-geographic-threats',
  standalone: true,
  imports: [CommonModule, ChartModule],
  templateUrl: './es-geographic-threats.component.html',
  styleUrl: './es-geographic-threats.component.scss',
})
export class EsGeographicThreatsComponent {
  geographicThreats = input<GeographicThreatsResponse>();
}
